// 登录弹窗组件

import React, { useState } from "react";
import { Button } from "@/components/ui";
import { Input } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/Dialog";
import { toast } from "sonner";
import { login } from "@/api/login";
import { useUserStore } from "@/store/UserStore";
import { getHistoryList } from "@/api/history";

interface LoginProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOpenRegister: () => void;
  onLoginSuccess: () => void;
}

export const LoginModal: React.FC<LoginProps> = ({
  open,
  onOpenChange,
  onOpenRegister,
  onLoginSuccess,
}) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { login: loginUser } = useUserStore();
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username || !password) {
      toast.error("请输入用户名和密码");
      return;
    }

    setIsLoading(true);

    try {
      const response = await login({ username, password });
      if (response && response.data && response.data.token) {
        loginUser(response.data.token);
        onLoginSuccess();
        toast.success("登录成功！");
        try {
          const historyResponse = await getHistoryList(1, 15);
          if (historyResponse.data && Array.isArray(historyResponse.data)) {
            window.dispatchEvent(
              new CustomEvent("historyListUpdated", {
                detail: { historyData: historyResponse.data },
              })
            );
          }
        } catch (historyError) {
          console.error("获取历史记录失败:", historyError);
        }
      } else {
        toast.error("登录失败，服务器响应异常");
      }
    } catch (error: any) {
      console.error("登录错误:", error);

      let errorMessage = "登录失败，请检查用户名和密码";

      if (error.response?.status === 401) {
        errorMessage = "用户名或密码错误";
      } else if (error.response?.status === 0) {
        errorMessage = "网络连接失败，请检查网络设置";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogDescription className="sr-only">
          请登录您的账号
        </DialogDescription>
        <DialogHeader className="mb-4">
          <DialogTitle className="text-2xl font-bold text-center">
            <DialogDescription className="text-sm text-center text-gray-500">
              请登录您的账号
            </DialogDescription>
            登录
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="username" className="text-sm font-medium">
              用户名
            </label>
            <Input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="请输入用户名"
              className="w-full"
              required
              autoComplete="username"
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="password" className="text-sm font-medium">
              密码
            </label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="请输入密码"
              className="w-full"
              required
              autoComplete="current-password"
            />
          </div>
          <Button type="submit" className="w-full mt-6" disabled={isLoading}>
            {isLoading ? "登录中..." : "登录"}
          </Button>
        </form>
        <div>
          <Button
            type="button"
            className="w-full mt-2"
            onClick={onOpenRegister}
          >
            注册账号
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
